// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"3af80daa-168":"ef24da6ec5e1011d051d","3af80daa-794":"c2b408f7105f80427c89","3af80daa-735":"ad097c741b4ac290cebe","3af80daa-91":"80d8e9980424defe810a"}[chunkId] + ".js";
};